function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-elecPrise");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-elecPrise"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/\\u2022bg-enjeux",
  transform: "translate(8.000000, 13.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bg-w",
  x: 0,
  y: 0,
  width: 14,
  height: 4
})), /*#__PURE__*/React.createElement("path", {
  d: "M15,7 C19.418278,7 23,10.581722 23,15 C23,19.418278 19.418278,23 15,23 C10.581722,23 7,19.418278 7,15 C7,10.581722 10.581722,7 15,7 Z M19,13.5 C18.1715729,13.5 17.5,14.1715729 17.5,15 C17.5,15.8284271 18.1715729,16.5 19,16.5 C19.8284271,16.5 20.5,15.8284271 20.5,15 C20.5,14.1715729 19.8284271,13.5 19,13.5 Z M11,13.5 C10.1715729,13.5 9.5,14.1715729 9.5,15 C9.5,15.8284271 10.1715729,16.5 11,16.5 C11.8284271,16.5 12.5,15.8284271 12.5,15 C12.5,14.1715729 11.8284271,13.5 11,13.5 Z",
  id: "Combined-Shape",
  fill: "#D93252"
})));

const SvgIco30ElecPrise = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30ElecPrise, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-elecPrise.3e7d31e3.svg";
export { ForwardRef as ReactComponent };